import Vue from "vue";
import Router from "vue-router";
import { getCookie } from "@/utils/utils.js";

Vue.use(Router);

const constantRouterMap = [
  {
    path: '/',
    name: 'list',
    meta: { auth: false },
    redirect: '/exhibitionAide',
  },
  // {
  //   path: "/index",
  //   name: "index",
  //   meta: { auth: false },
  //   component: () => import('../views/index')
  // },
  {
    path: "/list",
    name: "list",
    meta: { auth: false },
    component: () => import('../views/list')
  },
  {
    path: "/tanzhiying",
    name: "tanzhiying",
    meta: { auth: false },
    component: () => import('../views/projects/tanzhiying')
  },
  {
    path: "/cmbcProject",
    name: "cmbcProject",
    meta: { auth: false },
    component: () => import('../views/projects/cmbcProject')
  },
  {
    path: "/dengtaIntroProject",
    name: "dengtaIntroProject",
    meta: { auth: false },
    component: () => import('../views/projects/dengtaIntroProject')
  },
  {
    path: "/tanzhiwIntroProject",
    name: "tanzhiwIntroProject",
    meta: { auth: false },
    component: () => import('../views/projects/tanzhiwIntroProject')
  },
  {
    path: "/closeReview",
    name: "closeReview",
    meta: { auth: false },
    component: () => import('../views/projects/closeReview')
  },
  {
    path: "/northFunds",
    name: "northFunds",
    meta: { auth: false },
    component: () => import('../views/projects/northFunds')
  },
  {
    path: "/marketcapRaceStockA",
    name: "marketcapRaceStockA",
    meta: { auth: false },
    component: () => import('../views/projects/marketcapRaceStockA')
  },
  {
    path: "/dengtaBP",
    name: "dengtaBP",
    meta: { auth: false },
    component: () => import('../views/projects/dengtaBP')
  },
  {
    path: "/bossFestival",
    name: "bossFestival",
    meta: { auth: false },
    component: () => import('../views/projects/bossFestival')
  },
  {
    path: "/shortLineSnipe",
    name: "shortLineSnipe",
    meta: { auth: false },
    component: () => import('../views/projects/shortLineSnipe')
  },
  {
    path: "/chipDistribution",
    name: "chipDistribution",
    meta: { auth: false },
    component: () => import('../views/projects/chipDistribution')
  },
  {
    path: "/exhibitionAide",
    name: "exhibitionAide",
    meta: { auth: false },
    component: () => import('../views/projects/exhibitionAide')
  },
  {
    path: "/anyElementDemo",
    name: "anyElementDemo",
    meta: { auth: false },
    component: () => import('../views/demos/anyElementDemo')
  },
  {
    path: "/maskTextDemo",
    name: "maskTextDemo",
    meta: { auth: false },
    component: () => import('../views/demos/maskTextDemo')
  },
  {
    path: "/granimBgDemo",
    name: "granimBgDemo",
    meta: { auth: false },
    component: () => import('../views/demos/granimBgDemo')
  },
  {
    path: "/starryBackgroundDemo",
    name: "starryBackgroundDemo",
    meta: { auth: false },
    component: () => import('../views/demos/starryBackgroundDemo')
  },
  {
    path: "/scrambleTextDemo",
    name: "scrambleTextDemo",
    meta: { auth: false },
    component: () => import('../views/demos/scrambleTextDemo')
  },
  {
    path: "/animelTextDemo",
    name: "animelTextDemo",
    meta: { auth: false },
    component: () => import('../views/demos/animelTextDemo')
  },
  {
    path: "/horizenTransferDemo",
    name: "horizenTransferDemo",
    meta: { auth: false },
    component: () => import('../views/demos/horizenTransferDemo')
  },
  {
    path: "/staggerBarsTransferDemo",
    name: "staggerBarsTransferDemo",
    meta: { auth: false },
    component: () => import('../views/demos/staggerBarsTransferDemo')
  },
  {
    path: "/pixelWaveTransferDemo",
    name: "pixelWaveTransferDemo",
    meta: { auth: false },
    component: () => import('../views/demos/pixelWaveTransferDemo')
  },
  {
    path: "/graphTransferDemo",
    name: "graphTransferDemo",
    meta: { auth: false },
    component: () => import('../views/demos/graphTransferDemo')
  },
  {
    path: "/particleEffectDemo",
    name: "particleEffectDemo",
    meta: { auth: false },
    component: () => import('../views/demos/particleEffectDemo')
  },
  {
    path: "/barChartDemo",
    name: "barChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/barChartDemo')
  },
  {
    path: "/barChartDemo2",
    name: "barChartDemo2",
    meta: { auth: false },
    component: () => import('../views/demos/barChartDemo2')
  },
  {
    path: "/barStackedDemo",
    name: "barStackedDemo",
    meta: { auth: false },
    component: () => import('../views/demos/barStackedDemo')
  },
  {
    path: "/barRangeChartDemo",
    name: "barRangeChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/barRangeChartDemo')
  },
  {
    path: "/customTreeDemo",
    name: "customTreeDemo",
    meta: { auth: false },
    component: () => import('../views/demos/customTreeDemo')
  },
  {
    path: "/barDoubleDemo",
    name: "barDoubleDemo",
    meta: { auth: false },
    component: () => import('../views/demos/barDoubleDemo')
  },
  {
    path: "/barHistoryChartDemo",
    name: "barHistoryChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/barHistoryChartDemo')
  },
  {
    path: "/forceChartDemo",
    name: "forceChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/forceChartDemo')
  },
  {
    path: "/treeMapDemo",
    name: "treeMapDemo",
    meta: { auth: false },
    component: () => import('../views/demos/treeMapDemo')
  },
  {
    path: "/donutChartDemo",
    name: "donutChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/donutChartDemo')
  },
  {
    path: "/roseChartDemo",
    name: "roseChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/roseChartDemo')
  },
  {
    path: "/lineChartDemo",
    name: "lineChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/lineChartDemo')
  },
  {
    path: "/kLineChartDemo",
    name: "kLineChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/kLineChartDemo')
  },
  {
    path: "/blingBoxDemo",
    name: "blingBoxDemo",
    meta: { auth: false },
    component: () => import('../views/demos/blingBoxDemo')
  },
  {
    path: "/textShadeDemo",
    name: "textShadeDemo",
    meta: { auth: false },
    component: () => import('../views/demos/textShadeDemo')
  },
  {
    path: "/radarChartDemo",
    name: "radarChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/radarChartDemo')
  },
  {
    path: "/funnelChartDemo",
    name: "funnelChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/funnelChartDemo')
  },
  {
    path: "/gaugeChartDemo",
    name: "gaugeChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/gaugeChartDemo')
  },
  {
    path: "/ringGaugeChartDemo",
    name: "ringGaugeChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/ringGaugeChartDemo')
  },
  {
    path: "/legendDemo",
    name: "legendDemo",
    meta: { auth: false },
    component: () => import('../views/demos/legendDemo')
  },
  {
    path: "/marketChartDemo",
    name: "marketChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/marketChartDemo')
  },
  {
    path: "/biddingChartDemo",
    name: "biddingChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/biddingChartDemo')
  },
  {
    path: "/doubleYBarLineChartDemo",
    name: "doubleYBarLineChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/doubleYBarLineChartDemo')
  },
  {
    path: "/doubleYLinesChartDemo",
    name: "doubleYLinesChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/doubleYLinesChartDemo')
  },
  {
    path: "/barLineChartDemo",
    name: "barLineChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/barLineChartDemo')
  },
  {
    path: "/tableBarChartDemo",
    name: "tableBarChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/tableBarChartDemo')
  },
  {
    path: "/tableRankChartDemo",
    name: "tableRankChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/tableRankChartDemo')
  },
  {
    path: "/nLinesTimingChartDemo",
    name: "nLinesTimingChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/nLinesTimingChartDemo')
  },
  {
    path: "/dotDistChartDemo",
    name: "dotDistChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/dotDistChartDemo')
  },
  {
    path: "/evaluatingChartDemo",
    name: "evaluatingChartDemo",
    meta: { auth: false },
    component: () => import('../views/demos/evaluatingChartDemo')
  },
];

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    const position = { x: 0, y: 0 };
    if (savedPosition) {
      return savedPosition;
    }
    if (to.matched.some(m => m.meta.scrollToTop)) {
      position.x = 0;
      position.y = 0;
    }
    return position;
  },
  routes: constantRouterMap
});

// const getToken = () => {
//   return getCookie("token");
// };
router.beforeEach((to, from, next) => {
  //根据字段判断是否路由过滤
  if (to.matched.some(record => record.meta.auth)) {
    if (localStorage.loginInfo === undefined || !localStorage.loginInfo) {
      //防止无限循环
      if (to.name === "login") {
        next();
        return;
      }
      next({
        path: "/login"
      });
    } else {
      next()
    }
    // if (getToken() !== null) {
    //   // 本地缓存获取用户信息
    //   next();
    // } else {
    //   //防止无限循环
    //   if (to.name === "login") {
    //     next();
    //     return;
    //   }
    //   next({
    //     path: "/login"
    //   });
    // }
  } else {
    next();
  }
});

export default router;
